var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loginContainer" }, [
    _c("div", { staticClass: "login-content outer-container" }, [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              _vm.importUser()
            }
          }
        },
        [
          _c("div", { staticClass: "wellmetrics-event-pl" }, [
            _vm._v("WELLMETRICS EVENT PLANNER")
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "subText" }, [
            _vm._v(
              "Create, request and schedule biometric screening events with ADURO"
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "formInput" }, [
            _c("div", [
              _c("div", { staticClass: "form-title" }, [
                _vm._v(
                  "\n            Select file to import users to system.\n          "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row inputText" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "input-wrapper" }, [
                  _c("input", {
                    attrs: { type: "file", name: "file" },
                    on: { change: _vm.fileChange }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm._m(1)
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "labelText" }, [
      _c("label", [_vm._v("Please choose file")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row footerForm" }, [
      _c("input", { attrs: { type: "submit", value: "Upload" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f6899660", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6899660","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authorization/ImportUser.vue
// module id = 1938
// module chunks = 1